import React from 'react';
import { useTheme } from '@/contexts/ThemeContext';

export default function BrandLogo({ variant = 'default', className = '' }) {
  const { isDark } = useTheme();

  const logoImg = (height, extraClass = '') => (
    <img
      src="/onehedge-brand.png"
      alt="OneHedge"
      style={{ height: `${height}px`, width: 'auto' }}
      className={`object-contain ${isDark ? 'brightness-110 drop-shadow-[0_0_8px_rgba(0,255,163,0.15)]' : ''} ${extraClass}`}
    />
  );

  if (variant === 'icon') {
    return (
      <div className={`flex items-center ${className}`} data-testid="brand-logo-icon">
        <div className={`rounded-lg overflow-hidden ${isDark ? 'bg-white/10 p-1' : ''}`}>
          {logoImg(28)}
        </div>
      </div>
    );
  }

  if (variant === 'header') {
    return (
      <div className={`flex items-center ${className}`} data-testid="brand-logo-header">
        <div className={`rounded-lg overflow-hidden ${isDark ? 'bg-white/10 backdrop-blur-sm px-2 py-1' : ''}`}>
          {logoImg(30)}
        </div>
      </div>
    );
  }

  if (variant === 'auth') {
    return (
      <div className={`flex flex-col items-center gap-2 ${className}`} data-testid="brand-logo-auth">
        <div className={`rounded-xl overflow-hidden ${isDark ? 'bg-white/10 backdrop-blur-sm p-3' : ''}`}>
          {logoImg(72)}
        </div>
      </div>
    );
  }

  if (variant === 'footer') {
    return (
      <div className={`flex items-center ${className}`} data-testid="brand-logo-footer">
        <div className={`rounded-md overflow-hidden ${isDark ? 'bg-white/10 px-1.5 py-0.5' : ''}`}>
          {logoImg(20)}
        </div>
      </div>
    );
  }

  return (
    <div className={`flex items-center ${className}`} data-testid="brand-logo">
      <div className={`rounded-lg overflow-hidden ${isDark ? 'bg-white/10 backdrop-blur-sm px-2 py-1' : ''}`}>
        {logoImg(30)}
      </div>
    </div>
  );
}
